(() => {
  'use strict';
  const root = document.querySelector('[data-r3-product-cinematic][data-product-handle="tudca"]');
  const experience = root && root.querySelector('[data-r3-tudca-scroll-experience]');
  const video = experience && experience.querySelector('[data-r3-tudca-scroll-video]');
  if (!experience || !video) return;
  const sticky = experience.querySelector('.r3pp__scroll-sticky');

  const liver = experience.querySelector('[data-r3-tudca-liver-copy]');
  const digestion = experience.querySelector('[data-r3-tudca-digestion-copy]');
  const func = experience.querySelector('[data-r3-tudca-function-copy]');
  const ingredients = experience.querySelector('[data-r3-tudca-ingredients]');
  let ready = false, raf = 0, start = 0, range = 1, last = -1, retries = 0, retryTimer = 0;
  const sources = Array.from(video.querySelectorAll('source')).map(el => ({src: el.getAttribute('src'), media: el.getAttribute('media')}));
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const toggle = (el, visible) => { if (!el) return; el.classList.toggle('is-visible', visible); el.setAttribute('aria-hidden', String(!visible)); };

  function measure() {
    const rect = experience.getBoundingClientRect();
    start = window.scrollY + rect.top;
    range = Math.max(1, experience.offsetHeight - window.innerHeight);
    schedule();
  }
  function sync() {
    raf = 0;
    const progress = clamp((window.scrollY - start) / range, 0, 1);
    const inside = window.scrollY >= start && window.scrollY <= start + range;
    sticky.classList.toggle('is-active', inside);
    sticky.classList.toggle('is-ended', window.scrollY > start + range);
    const thresholdProgress = Math.min(1, progress + .002);
    const phone = window.matchMedia('(max-width: 749px)').matches;
    if (phone) {
      /* Match NAC phone timing: first fade at 7%, then 25/50/75%. */
      toggle(liver, thresholdProgress >= .072 && progress < .25);
      toggle(digestion, progress >= .25 && progress < .50);
      toggle(func, progress >= .50 && progress < .75);
      toggle(ingredients, progress >= .75);
    } else {
      toggle(liver, thresholdProgress >= .25);
      toggle(digestion, thresholdProgress >= .5);
      toggle(ingredients, thresholdProgress >= .5);
      toggle(func, thresholdProgress >= .75);
    }
    if (!ready) return;
    const duration = Number.isFinite(video.duration) ? video.duration : 10;
    const target = progress === 1 ? duration : progress * duration;
    if (Math.abs(target - last) < .002) return;
    last = target;
    video.pause();
    try { video.currentTime = target; } catch (_) {}
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(sync); }
  function frameReady() { if (video.readyState >= 2) video.classList.add('is-frame-ready'); }
  function armRetry() {
    clearTimeout(retryTimer);
    if (!video.classList.contains('is-frame-ready') && retries < 3) retryTimer = setTimeout(retryLoad, 5000);
  }
  function retryLoad() {
    if (video.readyState >= 2 || retries >= 3) return frameReady();
    retries += 1;
    const chosen = sources.find(({media}) => media && window.matchMedia(media).matches) || sources.find(({media}) => !media) || sources[0];
    video.src = chosen.src + (chosen.src.includes('?') ? '&' : '?') + 'r3retry=' + retries;
    try { video.load(); } catch (_) {}
    armRetry();
  }
  function metadata() { ready = Number.isFinite(video.duration) && video.duration > 0; video.pause(); measure(); armRetry(); }

  video.muted = true; video.defaultMuted = true; video.playsInline = true; video.autoplay = false; video.loop = false; video.controls = false; video.pause();
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', measure, {passive:true});
  window.addEventListener('orientationchange', measure, {passive:true});
  window.addEventListener('load', measure, {once:true});
  video.addEventListener('loadedmetadata', metadata, {once:true});
  video.addEventListener('durationchange', metadata);
  video.addEventListener('loadeddata', frameReady);
  video.addEventListener('seeked', frameReady);
  video.addEventListener('canplay', schedule);
  video.addEventListener('error', retryLoad);
  video.addEventListener('stalled', armRetry);
  video.addEventListener('play', () => video.pause());
  document.addEventListener('visibilitychange', () => { if (!document.hidden && video.readyState < 2) retryLoad(); });
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(experience);
  if (video.readyState >= 1) metadata(); else { video.load(); armRetry(); }
  measure();
})();
